import { create } from 'zustand';

export interface GoalDeposit {
  id: string;
  amount: number;
  date: Date;
  type: 'manual' | 'wallet';
  walletId: string | null;
}

export interface Goal {
  id: string;
  familyId: string;
  name: string;
  icon: string;
  color: string;
  target: number;
  deadline: Date | null;
  createdAt: Date;
  deposits: GoalDeposit[];
}

interface GoalsStore {
  goals: Goal[];
  setGoals: (g: Goal[]) => void;
  addGoal: (g: Goal) => void;
  updateGoal: (id: string, patch: Partial<Goal>) => void;
  removeGoal: (id: string) => void;
  addDeposit: (goalId: string, dep: GoalDeposit) => void;
  reset: () => void;
}

export const useGoalsStore = create<GoalsStore>((set) => ({
  goals: [],
  setGoals: (goals) => set({ goals }),
  addGoal: (g) => set((s) => ({ goals: [g, ...s.goals] })),
  updateGoal: (id, patch) =>
    set((s) => ({ goals: s.goals.map((g) => (g.id === id ? { ...g, ...patch } : g)) })),
  removeGoal: (id) => set((s) => ({ goals: s.goals.filter((g) => g.id !== id) })),
  addDeposit: (goalId, dep) =>
    set((s) => ({
      goals: s.goals.map((g) =>
        g.id === goalId ? { ...g, deposits: [...g.deposits, dep] } : g,
      ),
    })),
  reset: () => set({ goals: [] }),
}));

export function goalSaved(g: Goal): number {
  return g.deposits.reduce((s, d) => s + d.amount, 0);
}

export function goalProgress(g: Goal): number {
  if (g.target <= 0) return 0;
  return Math.min(100, Math.round((goalSaved(g) / g.target) * 100));
}
